export default class NotificationType {
    constructor(Rest) {
        this.rest = Rest.rest;
    }

    all() {
        console.log('sending request')
        return this.rest.one('notification-type').get()
    };

    customer() {
        return this.rest.one('notification-type/customer').get()
    };


}

NotificationType.$inject = ['Rest'];
